import React, { useEffect, useRef, useState } from "react";
import {
  Layout,
  // Card,
  // Divider,
  Typography,
  Collapse,
  Button,
  Timeline,
  Breadcrumb,
  Select,
  Form,
  Space,
  Input,
  Modal,
  Table,
  Tooltip,
  Spin,
} from "antd";
import {
  CloseOutlined,
  LeftOutlined,
  EyeOutlined,
  ClockCircleOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  DownloadOutlined,
  SignatureOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import {
  DirectionsRenderer,
  DirectionsService,
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import { Link, useNavigate } from "react-router-dom";
import ButtonField from "./../../common/htmlComponents/ButtonField";
import PropTypes from "prop-types";
import { Option } from "antd/lib/mentions";
import { getRequest } from "./../../axios/index";
import { useTranslation } from "react-i18next";
import { useRouteNameChanges } from "../../feature/RouteNameProvider";
import SearchIcon from "./../../image/SearchIcon.svg";
// import delivered from "../../image/delivered.png";
// import failed from "../../image/failed.png";
import { debounce } from "lodash";
import { authUserData } from "../../utils/Helper";

// import mapIcon from "../../image/mapicon.png";
import markegreen from "../../image/markegreen2.png";
import markeorange from "../../image/markeorange.png";
import markeredblack from "../../image/markeredblack.png";
import { ErrorNotificationMsg } from "../../utils/Notifications";

const { Sider, Content } = Layout;
const { Title, Text } = Typography;
const { Panel } = Collapse;

const containerStyle = {
  width: "100%",
  height: "100%",
  position: "relative",
};

// const deliveries = [
//   {
//     id: 1,
//     customer_name: "Nirav Kukadiya",
//     time: "11:00 AM",
//     customer_address:
//       "Kraft 7, GF, 4, Sarkhej - Gandhinagar Hwy, opp. Maruti Suzuki Showroom, Gota, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 21.086644,
//       longitude: 71.5289056,
//     },
//     status: "Done",
//     color: "green",
//   },
//   {
//     id: 2,
//     customer_name: "Bala subrahmanian gopinath",
//     time: "11:00 AM",
//     customer_address:
//       "Nr. Vishwanath Mahadev Mandir, Sarkhej - Gandhinagar Hwy, opp. Sanku Farm, near Gota Bridge, Vasant Nagar, Ognaj, Ahmedabad, Gujarat 380081",
//     coordinates: {
//       latitude: 22.086644,
//       longitude: 72.5289056,
//     },
//     status: "Done",
//     color: "green",
//   },
//   {
//     id: 3,
//     customer_name: "Arvind munjpara",
//     time: "11:00 AM",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 23.086644,
//       longitude: 73.5289056,
//     },
//     status: "Failed",
//     color: "red",
//   },
//   {
//     id: 4,
//     customer_name: "abc",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 24.086644,
//       longitude: 74.5289056,
//     },
//     status: "Loaded",
//     color: "gray",
//   },
//   {
//     id: 5,
//     customer_name: "abc",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 25.086644,
//       longitude: 75.5289056,
//     },
//     status: "Loaded",
//     color: "gray",
//   },
//   {
//     id: 6,
//     customer_name: "Nirav Kukadiya",
//     time: "11:00 AM",
//     customer_address:
//       "Kraft 7, GF, 4, Sarkhej - Gandhinagar Hwy, opp. Maruti Suzuki Showroom, Gota, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 26.086644,
//       longitude: 76.5289056,
//     },
//     status: "Done",
//     color: "green",
//   },
//   {
//     id: 7,
//     customer_name: "Bala subrahmanian gopinath",
//     time: "11:00 AM",
//     customer_address:
//       "Nr. Vishwanath Mahadev Mandir, Sarkhej - Gandhinagar Hwy, opp. Sanku Farm, near Gota Bridge, Vasant Nagar, Ognaj, Ahmedabad, Gujarat 380081",
//     coordinates: {
//       latitude: 27.086644,
//       longitude: 77.5289056,
//     },
//     status: "Done",
//     color: "green",
//   },
//   {
//     id: 8,
//     customer_name: "abc",
//     time: "11:00 AM",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 28.086644,
//       longitude: 78.5289056,
//     },
//     status: "Failed",
//     color: "red",
//   },
//   {
//     id: 9,
//     customer_name: "abc",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 23.086644,
//       longitude: 79.5289056,
//     },
//     status: "Loaded",
//     color: "gray",
//   },
//   {
//     id: 10,
//     customer_name: "abc",
//     customer_address:
//       "Kd Hospital, Sarkhej - Gandhinagar Hwy, Ahmedabad, Gujarat 382481",
//     coordinates: {
//       latitude: 25.3753,
//       longitude: 80.3451,
//     },
//     status: "Loaded",
//     color: "gray",
//   },
//   // Add other markers here...
// ];

const Routemap = () => {
  const { t } = useTranslation();
  const [packageData, setPackageData] = useState([]);
  const [selectedDelivery, setSelectedDelivery] = useState(
    packageData[0] || {}
  );

  // const [isVisible, setIsVisible] = useState(false);
  // const [imageUrl, setImageUrl] = useState("");
  // const [deliveries, setDeliveries] = useState([]);
  // const [count, setCount] = useState({});
  const { driverState, setDriverState } = useRouteNameChanges();
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const [totalCountPackages, setTotalCountPackages] = useState({
    package_loaded_count: 0,
    package_received_in_depo_count: 0,
    package_delivered_count: 0,
    package_failed_count: 0,
    package_in_transit_count: 0,
  });
  const [isModalVisibleNote, setIsModalVisibleNote] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingPDF, setBtnLoadingPDF] = useState(false);

  const handleOpenModal = () => {
    setIsModalVisibleNote(true);
  };

  const handleCloseModal = () => {
    setIsModalVisibleNote(false);
  };
  const markerDetails = (item) => {
    setSelectedMarker(item);
    handleDeliveryClick(item);
  };

  var pinColor = "#FFFFFF";
  // const initialDriverState = {
  //   driver: null,
  //   route_name: "",
  // }
  // const [driverState, setDriverState] = useState(initialDriverState);
  const [showInfo, setShowInfo] = useState(false);
  const [leftCollapsed, setLeftCollapsed] = useState(false);
  const [rightCollapsed, setRightCollapsed] = useState(true);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [loadingRoute, setLoadingRoute] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [routeName, setRouteName] = useState([]);
  const formRef = useRef();
  const [isModalVisible, setIsModalVisible] = useState(true);
  // const [isModalVisibleicon, setIsModalVisibleicon] = useState(false);
  const [isModalVisiblefailed, setIsModalVisiblefailed] = useState(false);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [form] = Form.useForm();
  const { Search } = Input;
  // Initialize map settings
  // const initializeMap = () => {
  //   const markers = packageData.map((item) => ({
  //     lat: item.coordinates.latitude,
  //     lng: item.coordinates.longitude,
  //   }));
  //   const center =
  //     markers.length > 0 ? markers[0] : { lat: 39.7817, lng: -89.6501 };
  //   const polylinePath = markers;
  //   return { center, polylinePath };
  // };

  // const { center, polylinePath } = initializeMap();

  const directionsCallback = (result, status) => {
    if (status === "OK") {
      setDirectionsResponse(result);
    } else {
      console.error("Directions request failed due to " + status);
    }
  };

  const getDriverName = async () => {
    try {
      const response = await getRequest("employee/drivers-list/");
      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
    } catch (error) {
      console.log("Error fetching driver list:", error);
    }
  };

  // useEffect(() => {
  //   const zoneGetById = async () => {
  //     try {
  //       const response = await getRequest(
  //         `package-model/package-by-driver-route/?route_id=${driverState.route_name}&driver_id=${driverState.driver}`,
  //         state
  //       );

  //       if (response.data.success) {
  //         const packageDataWithNotes = response.data.data.packages.map(
  //           (item) => {
  //             const notes = item.package_failed_delivery.map((note) => ({
  //               id: note.id,
  //               note: note.note,
  //               created_at: note.created_at,
  //               photo_upload: note.photo_upload,
  //             }));
  //             return { ...item, notes };
  //           }
  //         );

  //         // Sort the package data based on sequence_no
  //         const sortedPackages = packageDataWithNotes.sort(
  //           (a, b) => a.sequence_no - b.sequence_no
  //         );
  //         setPackageData(sortedPackages);
  //         setTotalCountPackages((prevState) => ({
  //           ...prevState,
  //           package_loaded_count: response.data.data?.package_loaded_count,
  //           package_received_in_depo_count:
  //             response.data.data?.package_received_in_depo_count,
  //           package_delivered_count:
  //             response.data.data?.package_delivered_count,
  //           package_failed_count: response.data.data?.package_failed_count,
  //           package_in_transit_count:
  //             response.data?.data.package_in_transit_count,
  //         }));
  //         // Plot the directions
  //         const directionsService = new window.google.maps.DirectionsService();

  //         const origin = {
  //           lat: sortedPackages[0].coordinates.latitude,
  //           lng: sortedPackages[0].coordinates.longitude,
  //         };

  //         const destination = {
  //           lat: sortedPackages[sortedPackages.length - 1].coordinates.latitude,
  //           lng: sortedPackages[sortedPackages.length - 1].coordinates
  //             .longitude,
  //         };

  //         const waypoints = sortedPackages?.slice(1, -1)?.map((pkg) => ({
  //           location: {
  //             lat: pkg.coordinates.latitude,
  //             lng: pkg.coordinates.longitude,
  //           },
  //           stopover: true,
  //         }));

  //         directionsService.route(
  //           {
  //             origin: origin,
  //             destination: destination,
  //             waypoints: waypoints,
  //             travelMode: window?.google?.maps?.TravelMode?.DRIVING,
  //           },
  //           (result, status) => {
  //             if (status === window?.google?.maps?.DirectionsStatus?.OK) {
  //               setDirectionsResponse(result);
  //             } else {
  //               console.error(`Error fetching directions ${result}`);
  //             }
  //           }
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error fetching package:", error);
  //     }
  //   };

  //   if (driverState.driver && driverState.route_name) {
  //     zoneGetById();
  //   }
  // }, [driverState, state]);

  useEffect(() => {
    const zoneGetById = async () => {
      setLoadingRoute(true);
      try {
        const response = await getRequest(
          `package-model/package-by-driver-route/?route_id=${driverState.route_name}&driver_id=${driverState.driver}`,
          state
        );

        if (response.data.success) {
          const packageDataWithNotes = response.data.data.packages.map(
            (item) => {
              const notes = item.package_failed_delivery.map((note) => ({
                id: note.id,
                note: note.note,
                created_at: note.created_at,
                photo_upload: note.photo_upload,
              }));
              return { ...item, notes };
            }
          );

          // Sort the package data based on sequence_no
          const sortedPackages = packageDataWithNotes.sort(
            (a, b) => a.sequence_no - b.sequence_no
          );
          setPackageData(sortedPackages);
          setTotalCountPackages((prevState) => ({
            ...prevState,
            package_loaded_count: response.data.data?.package_loaded_count,
            package_received_in_depo_count:
              response.data.data?.package_received_in_depo_count,
            package_delivered_count:
              response.data.data?.package_delivered_count,
            package_failed_count: response.data.data?.package_failed_count,
            package_in_transit_count:
              response.data?.data.package_in_transit_count,
          }));

          // Plot the directions using chunked waypoints
          const directionsService = new window.google.maps.DirectionsService();

          const origin = {
            lat: sortedPackages[0].coordinates.latitude,
            lng: sortedPackages[0].coordinates.longitude,
          };

          const destination = {
            lat: sortedPackages[sortedPackages.length - 1].coordinates.latitude,
            lng: sortedPackages[sortedPackages.length - 1].coordinates
              .longitude,
          };

          const allWaypoints = sortedPackages.slice(1, -1).map((pkg) => ({
            location: {
              lat: pkg.coordinates.latitude,
              lng: pkg.coordinates.longitude,
            },
            stopover: true,
          }));

          // Split waypoints into chunks of 25 or fewer
          const waypointChunks = [];
          for (let i = 0; i < allWaypoints.length; i += 25) {
            waypointChunks.push(allWaypoints.slice(i, i + 25));
          }

          let fullRoute = null;

          for (let i = 0; i < waypointChunks.length; i++) {
            const chunk = waypointChunks[i];

            const request = {
              origin:
                i === 0
                  ? origin
                  : fullRoute.routes[0].legs.slice(-1)[0].end_location,
              destination:
                i === waypointChunks.length - 1
                  ? destination
                  : chunk[chunk.length - 1].location,
              waypoints: chunk,
              travelMode: window.google.maps.TravelMode.DRIVING,
            };

            const result = await new Promise((resolve, reject) => {
              directionsService.route(request, (response, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                  resolve(response);
                } else {
                  reject(`Error fetching directions: ${status}`);
                }
              });
            });

            if (fullRoute) {
              // Merge the legs of the routes
              fullRoute.routes[0].legs = fullRoute.routes[0].legs.concat(
                result.routes[0].legs
              );
            } else {
              fullRoute = result;
            }
          }

          setDirectionsResponse(fullRoute);
          setLoadingRoute(false);
        }
      } catch (error) {
        console.error("Error fetching package:", error);
        setLoadingRoute(false);
      }
    };

    if (driverState.driver && driverState.route_name) {
      zoneGetById();
    }
    // setLoadingRoute(false);
  }, [driverState, state]);

  useEffect(() => {
    getDriverName();
    driverState?.driver !== null &&
    driverState?.driver !== undefined &&
    driverState?.driver !== ""
      ? getRouteByDriver(driverState?.driver)
      : console.log("");
  }, []);
  const handleDriverSelectChange = (value) => {
    setDriverState((prevState) => ({
      ...prevState,
      driver: value,
      route_name: null,
      // suburb: null,
    }));
    // formRef.current.setFieldsValue({ route_name: null });
    formRef.current.setFieldsValue({ driver: value, route_name: null });
    setRouteName([]);

    // setZones([]);
    getRouteByDriver(value);
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleRouteNameSelectChange = (value) => {
    setDriverState((prevState) => ({
      ...prevState,

      route_name: value,
      // suburb: null,
    }));
    formRef.current.setFieldsValue({ route_name: value });
  };
  const getRouteByDriver = async (id) => {
    const routeResponse = await getRequest(
      "route/route-name-by-driver/?driver_id=" + id
    );

    setRouteName(routeResponse?.data?.data);
  };
  // Define start and end points (example logic)
  const startPoint =
    packageData?.length > 0
      ? {
          lat: packageData[0]?.coordinates?.latitude,
          lng: packageData[0]?.coordinates?.longitude,
        }
      : null;
  const endPoint =
    packageData?.length > 0
      ? {
          lat: packageData[packageData?.length - 1]?.coordinates?.latitude,
          lng: packageData[packageData?.length - 1]?.coordinates?.longitude,
        }
      : null;
  useEffect(() => {
    if (packageData.length > 0) {
      setSelectedDelivery(packageData[0]);
    }
  }, [packageData]);

  const handleDeliveryClick = (delivery) => {
    setSelectedDelivery(delivery);
    setShowInfo(true);

    if (
      delivery.status === "Delivered" ||
      delivery.status === "Failed Delivery" ||
      delivery?.package_photo_upload.length !== 0 ||
      delivery?.package_failed_delivery.length !== 0
    ) {
      setRightCollapsed(false);
    } else {
      setRightCollapsed(true);
    }
  };

  const handleCloseInfo = () => {
    setShowInfo(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const navigate = useNavigate();
  // const handleGoToPackage = () => {
  //   navigate("../package"); // Navigate to the package page
  // };
  // const updateFormValues = () => {
  //   formRef.current.setFieldsValue({
  //     driver: driverState.driver,
  //     route_name: driverState.route_name,
  //   });
  // };
  // const handleShowRoute = () => {
  //   formRef.current.setFieldsValue({
  //     driver: driverState.driver,
  //     route_name: driverState.route_name,
  //   });
  //   setIsModalVisible(false);
  // };

  const columns = [
    {
      title: "Date And Time",
      dataIndex: "date",
      key: "date",
      sorter: true,
    },
    {
      title: "Day",
      dataIndex: "day",
      key: "day",
      sorter: true,
    },
    // {
    //   title: "Time",
    //   dataIndex: "time",
    //   key: "time",
    // },
    {
      title: "Address",
      dataIndex: "customer_address",
      key: "customer_address",
      sorter: true,
    },
    {
      title: "Failed Reason",
      dataIndex: "failed_reason",
      key: "failed_reason",
      sorter: true,
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      sorter: true,
    },
  ];

  packageData.filter((item) => item.status === "failed");
  // const [currentNote, setCurrentNote] = useState(null);
  // const handleIconClick = (note) => {
  //   setCurrentNote(note); // Set the current note for which to show images
  //   setIsModalVisibleicon(true); // Open the modal
  // };

  // const handleCancel = () => {
  //   setIsModalVisibleicon(false);
  //   setIsModalVisiblefailed(false);
  //   setCurrentNote(null);
  // };
  const [currentNote, setCurrentNote] = useState(null);
  const [isModalVisibleNote2, setIsModalVisibleNote2] = useState(false);

  const handleIconClick = (note) => {
    setCurrentNote(note);
    setIsModalVisibleNote2(true);
  };

  const handleCancel = () => {
    setIsModalVisibleNote2(false);
    setCurrentNote(null);
  };

  const [currentNoteDelivered, setCurrentNoteDelivered] = useState(null);
  const [currentNoteSignature, setCurrentNoteSignature] = useState(null);
  const [isModalVisibleDelivered, setIsModalVisibleDelivered] = useState(false);
  const [isModalVisibleSignature, setIsModalVisibleSignature] = useState(false);

  const handleIconClickDelivered = (note) => {
    setCurrentNoteDelivered(note);
    setIsModalVisibleDelivered(true);
  };

  const handleCancelDelivered = () => {
    setIsModalVisibleDelivered(false);
    setCurrentNoteDelivered(null);
  };

  const handleIconClickSignature = (note) => {
    setCurrentNoteSignature(note);
    setIsModalVisibleSignature(true);
  };

  const handleCancelSignature = () => {
    setIsModalVisibleSignature(false);
    setCurrentNoteSignature(null);
  };
  // const handlefailedClick = () => {
  //   setIsModalVisiblefailed(true);
  // };

  const OverlappingMarker = ({ position, label, title, onClick }) => (
    <Marker position={position} label={label} title={title} onClick={onClick} />
  );

  OverlappingMarker.propTypes = {
    position: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    label: PropTypes.shape({
      text: PropTypes.string.isRequired,
      color: PropTypes.string,
      fontSize: PropTypes.string,
      fontWeight: PropTypes.string,
    }).isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  const getOverlappingMarkerPositions = (markers) => {
    const positions = {};
    const offsetValue = 0.000006; // Adjust this value for better visibility

    return markers.map((marker, index) => {
      const { latitude, longitude } = marker.coordinates;
      // (marker.coordinates ?? {})
      // Adjust position if there is an overlap
      const positionKey = `${latitude},${longitude}`;
      if (!positions[positionKey]) {
        positions[positionKey] = 0; // Initialize count for this position
      }
      positions[positionKey] += 1;

      // Use a higher offset to visibly separate markers
      const offset = (positions[positionKey] - 1) * offsetValue;

      return {
        ...marker,
        coordinates: {
          latitude: latitude + offset, // Apply the offset to latitude
          longitude: longitude + offset, // Apply the offset to longitude
        },
      };
    });
  };
  // Call this function before rendering markers
  const adjustedPackageData = getOverlappingMarkerPositions(packageData);

  const handleDownload = async (id) => {
    if (!id) {
      console.error("No ID provided for downloading the pdf.");
      return;
    }
    setBtnLoadingPDF(true);
    try {
      // Construct the API endpoint using the id
      const endpoint = `package-model/${id}/pod-download-by-package-id/`;

      // Send a GET request to the endpoint
      const response = await getRequest(endpoint);

      // Process and download the pdf file
      const blob = new Blob([response.data], { type: "text/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Package_List_${Date.now()}.pdf`;
      link.click();
      link.remove(); // Clean up the DOM element
      setBtnLoadingPDF(false);
    } catch (error) {
      setBtnLoadingPDF(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        ErrorNotificationMsg(t("file_not_found"));
        setBtnLoadingPDF(false);
      } else {
        console.error("Error downloading the file:", error);
        ErrorNotificationMsg(t("error_downloading_file"));
        setBtnLoadingPDF(false);
      }
    }
  };

  const handleDownloadRouteCsv = async () => {
    if (!driverState.route_name) {
      console.error("No ID provided for downloading the CSV.");
      return;
    }
    setBtnLoading(true);
    try {
      // Construct the API endpoint using the id
      const endpoint = `route/${driverState.route_name}/route-csv-download/`;

      // Send a GET request to the endpoint
      const response = await getRequest(endpoint);

      // Process and download the CSV file
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Package_List_${Date.now()}.csv`;
      link.click();
      link.remove(); // Clean up the DOM element
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        ErrorNotificationMsg(t("file_not_found"));
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        ErrorNotificationMsg(t("error_downloading_file"));
        setBtnLoading(false);
      }
    }
  };

  return (
    <>
      <div className="ListingTopBar routmap">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Optimized Routes</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Optimized Routes</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="route-status">
              {/* <div className="number lightblue">
                <div className="widcont">
                  <span>Received in Depo</span>
                  <Title level={3}>
                    {totalCountPackages?.package_received_in_depo_count || 0}{" "}

                  </Title>
                </div>
              </div> */}

              <div className="number lightorange">
                <div className="widcont">
                  <span>Loaded By Driver</span>
                  <Title level={3}>
                    {totalCountPackages?.package_loaded_count || 0}{" "}
                    {/* <small className="bnb2">+30%</small> */}
                  </Title>
                </div>
              </div>
              <div className="number lightgreen">
                <div className="widcont">
                  <span>Delivered</span>
                  <Title level={3}>
                    {totalCountPackages?.package_delivered_count || 0}{" "}
                    {/* <small className="bnb2">+20%</small> */}
                  </Title>
                </div>
              </div>
              <div className="number lightred">
                <div className="widcont">
                  <span>Failed Delivery</span>
                  <Title level={3}>
                    {totalCountPackages?.package_failed_count || 0}{" "}
                    {/* <small className="bnb2">-20%</small> */}
                  </Title>
                </div>
              </div>
              <div className="number lightgray">
                <div className="widcont">
                  <span>In Transit</span>
                  <Title level={3}>
                    {totalCountPackages?.package_in_transit_count || 0}{" "}
                  </Title>
                </div>
              </div>
            </div>

            <div className="optrouteaction">
              {driverState?.route_name && (
                <ButtonField
                  className="BlueShadowBtnRoute"
                  type="primary"
                  htmlType="button"
                  loading={btnLoading}
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                      Route CSV
                    </span>
                  }
                  onClick={() => handleDownloadRouteCsv(selectedDelivery.id)}
                />
              )}
              <Form ref={formRef}>
                <Form.Item
                  name="driver"
                  rules={[
                    {
                      required: true,
                      message: t("Please select a driver!"),
                    },
                  ]}
                  initialValue={driverState.driver} // Set the initial value
                >
                  <Select
                    placeholder={t("val_driver")}
                    showArrow
                    showSearch
                    value={driverState?.driver}
                    optionFilterProp="children"
                    style={{ minWidth: "140px", textAlign: "left" }}
                    // onChange={() => setPopConfirmVisible(true)}
                    onChange={handleDriverSelectChange}
                  >
                    {driverList?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="route_name"
                  rules={[
                    {
                      required: true,
                      message: t("Please Select Route!"),
                    },
                  ]}
                  initialValue={driverState?.route_name} // Set the initial value
                >
                  <Select
                    placeholder={t("Select Route")}
                    showArrow
                    showSearch
                    optionFilterProp="children"
                    value={driverState?.route_name}
                    style={{ minWidth: "210px", textAlign: "left" }}
                    onChange={handleRouteNameSelectChange}
                    // onChange={() => setPopConfirmVisible(true)}
                  >
                    {routeName?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.route_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
              {/*  <ButtonField
              className="BlueShadowBtnRoute"
              type="primary"
              htmlType="button"
              size="medium"
              label="Show Routes"
            // onClick={() => handleShowRoute()}
            />*/}
              {authUserData()?.permission.includes("package|view_route") && (
                <ButtonField
                  className="BlueShadowBtnRoute"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Show All Routes"
                  onClick={() => navigate("/route-list")}
                />
              )}
            </div>
          </Space>
        </div>
      </div>
      <Spin spinning={loadingRoute}>
        <div className="routmapwrap">
          <Layout style={{ height: "calc(100vh - 105px)" }}>
            {/* Left Sidebar */}
            <Sider
              width={300}
              collapsible
              collapsed={leftCollapsed}
              onCollapse={(collapsed) => setLeftCollapsed(collapsed)}
              trigger={null}
              className="timelinecol"
              theme="light"
            >
              <div className="mapsearch">
                <div className="searchwrp">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        // value={state.search}
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                        style={{
                          width: 250,
                        }}
                        // placeholder={t("pl_search_list")}
                      />
                    </Form.Item>
                  </Form>
                </div>
              </div>
              {!leftCollapsed && (
                <Timeline>
                  {packageData.map((item, index) => {
                    let itemBackgroundColor = "white"; // Default background color

                    // Set background color based on the status
                    if (item.status === "Failed Delivery") {
                      itemBackgroundColor = "#ffe6e6"; // Failed status
                    } else if (item.status === "Delivered") {
                      itemBackgroundColor = "#ebffec"; // Delivered status
                    }

                    return (
                      <Timeline.Item
                        color={item.color}
                        key={item.id}
                        className={item.status}
                        dot={<>{`${index + 1}`}</>}
                        onClick={() => handleDeliveryClick(item)}
                        style={{ backgroundColor: itemBackgroundColor }} // Apply background color
                      >
                        <div className="timelinetitle">{item.hawb}</div>
                        <div className="timelinetitle">
                          {item.customer_name}
                          <div className="timestatus">
                            {" "}
                            {item?.status_change_time?.split(" ")[1]}
                          </div>
                        </div>

                        <div className="descp">
                          <p>{item.customer_address}</p>
                          <div className="delvstatus">
                            <span>{item.status}</span>
                          </div>
                        </div>
                      </Timeline.Item>
                    );
                  })}
                </Timeline>
              )}
            </Sider>

            <Modal
              visible={isModalVisiblefailed}
              onCancel={handleCancel}
              footer={null}
              centered
              title={`Failed Delivery - ${
                selectedDelivery?.customer_name || ""
              } (${selectedDelivery?.parcelNo || "0"})`}
              width={700}
            >
              <section className="grid-sec mt-5">
                {/* <div className="PR-body"> */}
                <Table
                  columns={columns}
                  // dataSource={failedDeliveries}
                  rowKey="id"
                  pagination={false} // Disable pagination if not needed
                />
                {/* </div> */}
              </section>
            </Modal>

            <Layout style={{ flex: 1 }}>
              <Layout
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Content style={{ padding: "0 0", flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "",
                      height: "100%",
                    }}
                  >
                    {showInfo && (
                      // <div>
                      <div className="destinationinfo">
                        <div className="desti-head">
                          <Title level={4}>Destination Info</Title>

                          <Button
                            icon={<CloseOutlined />}
                            onClick={handleCloseInfo}
                            type="text"
                          />
                        </div>
                        {/* {packageData.map((item, index) => ( */}
                        <Button
                          cursor="pointer"
                          type="Button"
                          className="ant-btn ant-btn-primary BlueShadowBtnRoute"
                          style={{
                            fontSize: "30",
                            marginLeft: "5px",
                            height: "40px",
                          }}
                          onClick={() => handleDownload(selectedDelivery?.id)}
                          loading={btnLoadingPDF}
                        >
                          <span>
                            <Tooltip
                              placement="start"
                              title={
                                <span style={{ color: "#fff" }}>
                                  Download pdf
                                </span>
                              }
                            >
                              <DownloadOutlined
                                style={{
                                  fontSize: "20px",
                                  color: "#fff",
                                }}
                              />
                              <span style={{ color: "#fff", fontSize: "16px" }}>
                                {" "}
                                Download POD
                              </span>
                            </Tooltip>
                          </span>
                        </Button>
                        {selectedDelivery && (
                          <Collapse defaultActiveKey={["1"]}>
                            <Panel header="Address" key="1">
                              <Text strong>Receiver Name: </Text>{" "}
                              {selectedDelivery?.customer_name || "N/A"} <br />
                              <Text strong>Address: </Text>{" "}
                              {selectedDelivery?.customer_address || "N/A"}{" "}
                              <br />
                              <Text strong>Lat & Lng: </Text>{" "}
                              {selectedDelivery?.coordinates?.latitude || "N/A"}
                              ,{" "}
                              {selectedDelivery?.coordinates?.longitude ||
                                "N/A"}{" "}
                              <br />
                              {/* <Text strong>Destination Type: </Text> DELIVERY{" "} */}
                              <br />
                            </Panel>
                            <Panel header="Order" key="2">
                              <Text strong>Tracking No: </Text>{" "}
                              {selectedDelivery.hawb || "N/A"} <br />
                              <Text strong>Pieces: </Text>{" "}
                              {selectedDelivery.count || "N/A"} <br />
                              {/* <Text strong>Priority: </Text>{" "}
                            {selectedDelivery.priority || "N/A"} <br /> */}
                            </Panel>
                            <Panel header="Customer" key="3">
                              <Text strong>First Name: </Text>{" "}
                              {selectedDelivery.customer_name
                                ? selectedDelivery.customer_name?.split(" ")[0]
                                : "N/A"}{" "}
                              <br />
                              <Text strong>Phone: </Text>{" "}
                              {selectedDelivery.customer_phone
                                ? selectedDelivery.customer_phone?.split(" ")[0]
                                : "N/A"}{" "}
                              <br />
                            </Panel>
                            <Panel header="Visit Details" key="4">
                              <Text strong>Service Time: </Text>{" "}
                              {/* {selectedDelivery.time || "N/A"} */}
                              {selectedDelivery?.status_change_time?.split(
                                " "
                              )[1] || "N/A"}
                              <br />
                            </Panel>
                            {/* <Panel header="Vehicle Utilization" key="5">
                            <Text strong>Max Vehicle Capacity: </Text>{" "}
                            {selectedDelivery.maxCapacity || "N/A"} <br />
                            <Text strong>Current Utilization: </Text>{" "}
                            {selectedDelivery.currentUtilization || "N/A"}{" "}
                            <br />
                            <Text strong>Delivered: </Text>{" "}
                            {selectedDelivery.delivered || "N/A"} <br />
                            <Text strong>Picked-up: </Text>{" "}
                            {selectedDelivery.pickedUp || "N/A"} <br />
                          </Panel> */}
                          </Collapse>
                        )}
                      </div>

                      // </div>
                    )}
                    {/* <div style={{ flex: 1 }}> */}
                    <Sider
                      width={300}
                      collapsedWidth={26}
                      collapsible
                      collapsed={rightCollapsed}
                      onCollapse={(collapsed) => setRightCollapsed(collapsed)}
                      trigger={null}
                      className="mapnoteinfo"
                      theme="light"
                    >
                      {selectedDelivery && (
                        <>
                          <div className="mapnote-head">
                            {rightCollapsed ? (
                              <LeftOutlined
                                onClick={() =>
                                  setRightCollapsed(!rightCollapsed)
                                }
                              />
                            ) : (
                              <>
                                <Title level={4}>Note</Title>

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {/* <Button
                                          cursor="pointer"
                                          type="Button"
                                          className="ant-btn ant-btn-primary BlueShadowBtnRoute"
                                          style={{
                                            fontSize: "12",
                                            marginLeft: "5px",
                                            height: "24px",
                                          }}
                                          onClick={() =>
                                            handleDownload(selectedDelivery?.id)
                                          }
                                          loading={btnLoadingPDF}
                                        >
                                          <span>
                                            <Tooltip
                                              placement="start"
                                              title={
                                                <span style={{ color: "#fff" }}>
                                                  Download pdf
                                                </span>
                                              }
                                            >
                                              <DownloadOutlined
                                                style={{
                                                  fontSize: "16px",
                                                  color: "#fff",
                                                }}
                                              />
                                              <span style={{ color: "#fff" }}>
                                                {" "}
                                                Download POD
                                              </span>
                                            </Tooltip>
                                          </span>
                                        </Button> */}
                                  <Button
                                    icon={<CloseOutlined />}
                                    onClick={() =>
                                      setRightCollapsed(!rightCollapsed)
                                    }
                                    type="text"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          {!rightCollapsed && (
                            <>
                              {/* <h5 className="heading">
                        {selectedDelivery.package_failed_delivery?.length > 0 &&
                        selectedDelivery.package_photo_upload?.length === 0
                          ? "Only Fail"
                          : selectedDelivery.package_photo_upload?.length > 0 &&
                            selectedDelivery.package_failed_delivery?.length ===
                              0
                          ? "Only Deliver"
                          : selectedDelivery.package_failed_delivery?.length >
                              0 &&
                            selectedDelivery.package_photo_upload?.length > 0
                          ? "Fail and Deliver"
                          : "Note"}
                      </h5> */}

                              {/* Render notes based on status */}
                              {selectedDelivery?.status === "Delivered" ? (
                                <>
                                  {/* Delivered Notes First */}
                                  {selectedDelivery?.package_photo_upload
                                    ?.length > 0 && (
                                    <>
                                      <h4 className="heading">
                                        Delivered Notes
                                      </h4>
                                      {selectedDelivery.package_photo_upload.map(
                                        (item) => (
                                          <div
                                            key={item.id}
                                            className="notecard"
                                          >
                                            {item?.photo_upload && ( // Check if photo_upload exists
                                              <div className="notetype">
                                                Photo
                                                <CameraOutlined
                                                  onClick={() =>
                                                    handleIconClickDelivered(
                                                      item
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={
                                                    isModalVisibleDelivered
                                                  }
                                                  onCancel={
                                                    handleCancelDelivered
                                                  }
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNoteDelivered && (
                                                    <img
                                                      src={
                                                        currentNoteDelivered?.photo_upload
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            {item?.signature?.[0]
                                              ?.signature && ( // Check if signature exists
                                              <div className="notetype">
                                                Signature
                                                <SignatureOutlined
                                                  onClick={() =>
                                                    handleIconClickSignature(
                                                      item
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={
                                                    isModalVisibleSignature
                                                  }
                                                  onCancel={
                                                    handleCancelSignature
                                                  }
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNoteSignature && (
                                                    <img
                                                      src={
                                                        currentNoteSignature
                                                          ?.signature[0]
                                                          ?.signature
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            <ul>
                                              {/* {item?.signature?.[0]
                                                ?.signature && ( */}
                                              <li>
                                                <SignatureOutlined />
                                                {"Signed by :  "}
                                                {selectedDelivery?.signature_person_name ||
                                                  "N/A"}
                                              </li>
                                              {/* )} */}
                                              <li>
                                                <ClockCircleOutlined />{" "}
                                                {item?.created_at || "N/A"}
                                              </li>
                                              <li>
                                                <HomeOutlined />
                                                {selectedDelivery?.customer_address ||
                                                  "N/A"}
                                              </li>
                                              <li>
                                                <EnvironmentOutlined />
                                                {item.driver_latitude},{" "}
                                                {item.driver_longitude}
                                              </li>
                                            </ul>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}
                                  {/* Failed Delivery Notes Next */}
                                  {selectedDelivery?.package_failed_delivery
                                    ?.length > 0 && (
                                    <>
                                      <h4 className="heading">
                                        Failed Delivery Notes
                                      </h4>
                                      {selectedDelivery.package_failed_delivery.map(
                                        (item) => (
                                          <div
                                            key={item.id}
                                            className="notecard"
                                          >
                                            {item?.photo_upload && ( // Check if photo_upload exists
                                              <div className="notetype">
                                                Photo
                                                <CameraOutlined
                                                  onClick={() =>
                                                    handleIconClick(item)
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={isModalVisibleNote2}
                                                  onCancel={handleCancel}
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNote && (
                                                    <img
                                                      src={
                                                        currentNote?.photo_upload
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            <ul>
                                              <li>
                                                <ClockCircleOutlined />{" "}
                                                {item?.created_at || "N/A"}
                                              </li>
                                              <li>
                                                <HomeOutlined />
                                                {selectedDelivery?.customer_address ||
                                                  "N/A"}
                                              </li>
                                              <li>
                                                <EnvironmentOutlined />
                                                {item.driver_latitude},{" "}
                                                {item.driver_longitude}
                                              </li>
                                            </ul>
                                            <div className="notetype">
                                              Reasons
                                            </div>
                                            <ul
                                              style={{
                                                margin: 0,
                                                padding: 0,
                                                listStyleType: "none",
                                              }}
                                            >
                                              {item.package_delivery_status?.map(
                                                (status) => (
                                                  <li key={status.id}>
                                                    {status.name}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                            <div className="notetype">
                                              Other Reasons
                                            </div>
                                            <ul
                                              style={{
                                                margin: 0,
                                                padding: 0,
                                                listStyleType: "none",
                                              }}
                                            >
                                              <li>
                                                {item?.other_reasons || "N/A"}
                                              </li>
                                            </ul>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* Failed Delivery Notes Next */}
                                  {selectedDelivery?.package_failed_delivery
                                    ?.length > 0 && (
                                    <>
                                      <h4 className="heading">
                                        Failed Delivery Notes
                                      </h4>
                                      {selectedDelivery.package_failed_delivery.map(
                                        (item) => (
                                          <div
                                            key={item.id}
                                            className="notecard"
                                          >
                                            {item?.photo_upload && ( // Check if photo_upload exists
                                              <div className="notetype">
                                                Photo
                                                <CameraOutlined
                                                  onClick={() =>
                                                    handleIconClick(item)
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={isModalVisibleNote2}
                                                  onCancel={handleCancel}
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNote && (
                                                    <img
                                                      src={
                                                        currentNote?.photo_upload
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            <ul>
                                              <li>
                                                <ClockCircleOutlined />{" "}
                                                {item?.created_at || "N/A"}
                                              </li>
                                              <li>
                                                <HomeOutlined />
                                                {selectedDelivery?.customer_address ||
                                                  "N/A"}
                                              </li>
                                              <li>
                                                <EnvironmentOutlined />
                                                {item.driver_latitude},{" "}
                                                {item.driver_longitude}
                                              </li>
                                            </ul>
                                            <div className="notetype">
                                              Reasons
                                            </div>
                                            <ul
                                              style={{
                                                margin: 0,
                                                padding: 0,
                                                listStyleType: "none",
                                              }}
                                            >
                                              {item.package_delivery_status?.map(
                                                (status) => (
                                                  <li key={status.id}>
                                                    {status.name}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                            <div className="notetype">
                                              Other Reasons
                                            </div>
                                            <ul
                                              style={{
                                                margin: 0,
                                                padding: 0,
                                                listStyleType: "none",
                                              }}
                                            >
                                              <li>
                                                {item?.other_reasons || "N/A"}
                                              </li>
                                            </ul>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}
                                  {/* Delivered Notes First */}
                                  {selectedDelivery?.package_photo_upload
                                    ?.length > 0 && (
                                    <>
                                      <h4 className="heading">
                                        Delivered Notes
                                      </h4>
                                      {selectedDelivery.package_photo_upload.map(
                                        (item) => (
                                          <div
                                            key={item.id}
                                            className="notecard"
                                          >
                                            {item?.photo_upload && ( // Check if photo_upload exists
                                              <div className="notetype">
                                                Photo
                                                <CameraOutlined
                                                  onClick={() =>
                                                    handleIconClickDelivered(
                                                      item
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={
                                                    isModalVisibleDelivered
                                                  }
                                                  onCancel={
                                                    handleCancelDelivered
                                                  }
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNoteDelivered && (
                                                    <img
                                                      src={
                                                        currentNoteDelivered?.photo_upload
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            {item?.signature?.[0]
                                              ?.signature && ( // Check if signature exists
                                              <div className="notetype">
                                                Signature
                                                <SignatureOutlined
                                                  onClick={() =>
                                                    handleIconClickSignature(
                                                      item
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    fontSize: "22px",
                                                  }}
                                                />
                                                <Modal
                                                  visible={
                                                    isModalVisibleSignature
                                                  }
                                                  onCancel={
                                                    handleCancelSignature
                                                  }
                                                  footer={null}
                                                  centered
                                                  title="Image"
                                                  width={700}
                                                >
                                                  {currentNoteSignature && (
                                                    <img
                                                      src={
                                                        currentNoteSignature
                                                          ?.signature[0]
                                                          ?.signature
                                                      }
                                                      alt="Image"
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    />
                                                  )}
                                                </Modal>
                                              </div>
                                            )}
                                            <ul>
                                              <li>
                                                <ClockCircleOutlined />{" "}
                                                {item?.created_at || "N/A"}
                                              </li>
                                              <li>
                                                <HomeOutlined />
                                                {selectedDelivery?.customer_address ||
                                                  "N/A"}
                                              </li>
                                              <li>
                                                <EnvironmentOutlined />
                                                {item.driver_latitude},{" "}
                                                {item.driver_longitude}
                                              </li>
                                            </ul>
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </Sider>
                    {/* </div> */}
                    <div style={{ flex: 1 }}>
                      {/* <LoadScript
                      googleMapsApiKey={
                        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                      }
                    >
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={
                          startPoint
                            ? {
                                lat: startPoint.latitude,
                                lng: startPoint.longitude,
                              }
                            : { lat: -33.865143, lng: 151.2099 } // Default center if no points
                        }
                        zoom={12}
                      >
                        {packageData.map((item, index) => (
                          <Marker
                            key={item.id}
                            position={{
                              lat: item.coordinates.latitude,
                              lng: item.coordinates.longitude,
                            }}
                            label={{
                              text: `${index + 1}`,
                              color: "white",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                            title={item.customer_address}
                            onClick={() => setSelectedMarker(item)}
                          />
                        ))}

                        {startPoint && endPoint && (
                          <DirectionsService
                            options={{
                              origin: {
                                lat: startPoint.latitude,
                                lng: startPoint.longitude,
                              },
                              destination: {
                                lat: endPoint.latitude,
                                lng: endPoint.longitude,
                              },
                              travelMode: "DRIVING",
                              waypoints: packageData
                                .slice(1, -1)
                                .map((item) => ({
                                  location: {
                                    lat: item.coordinates.latitude,
                                    lng: item.coordinates.longitude,
                                  },
                                })),
                            }}
                            callback={directionsCallback}
                          />
                        )}

                        {directionsResponse && (
                          <DirectionsRenderer
                            directions={directionsResponse}
                            options={{
                              suppressMarkers: true, // Optional: Hide default markers
                              polylineOptions: {
                                strokeColor: "#FF0000", // Route line color
                                strokeOpacity: 0.8,
                                strokeWeight: 5,
                              },
                            }}
                          />
                        )}

                        {selectedMarker && (
                          <InfoWindow
                            position={{
                              lat: selectedMarker.coordinates.latitude,
                              lng: selectedMarker.coordinates.longitude,
                            }}
                            onCloseClick={() => setSelectedMarker(null)}
                          >
                            <div>
                              <h6 style={{ margin: 0 }}>
                                Address: {selectedMarker.customer_address}
                              </h6>
                            </div>
                          </InfoWindow>
                        )}

                        {startPoint && (
                          <Marker
                            position={{
                              lat: startPoint.latitude,
                              lng: startPoint.longitude,
                            }}
                            label="Start"
                          />
                        )}
                        {endPoint && (
                          <Marker
                            position={{
                              lat: endPoint.latitude,
                              lng: endPoint.longitude,
                            }}
                            label="End"
                          />
                        )}
                      </GoogleMap>
                    </LoadScript> */}

                      {/* <LoadScript
                      googleMapsApiKey={
                        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                      }
                    >
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={
                          startPoint
                            ? {
                              lat: startPoint.latitude,
                              lng: startPoint.longitude,
                            }
                            : { lat: -25.2744, lng: 133.7751 }
                        }
                        zoom={6}
                      >
                        <MarkerClusterer
                          options={{
                            maxZoom: 18, // Set max zoom to stop clustering at this zoom level
                            gridSize: 50, // Adjust grid size for clustering
                            styles: [
                              {
                                url: mapIcon, // Custom cluster icon URL
                                height: 70, // Height of the icon
                                width: 70, // Width of the icon
                                textColor: "#000", // Color of the text inside the icon
                                textSize: 14, // Size of the text
                              },
                            ],
                          }}
                        >
                          {(clusterer) =>
                            adjustedPackageData.map((item, index) => (
                              <Marker
                                key={item.id}
                                position={{
                                  lat: item.coordinates.latitude,
                                  lng: item.coordinates.longitude,
                                }}
                                label={{
                                  text: `${index + 1}`,
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                                title={item.customer_address}
                                onClick={() => setSelectedMarker(item)}
                                clusterer={clusterer} // Use the clusterer prop
                              />
                            ))
                          }
                        </MarkerClusterer>

                        {startPoint && endPoint && (
                          <DirectionsService
                            options={{
                              origin: {
                                lat: startPoint.latitude,
                                lng: startPoint.longitude,
                              },
                              destination: {
                                lat: endPoint.latitude,
                                lng: endPoint.longitude,
                              },
                              travelMode: "DRIVING",
                              waypoints: packageData
                                .slice(1, -1)
                                .map((item) => ({
                                  location: {
                                    lat: item.coordinates.latitude,
                                    lng: item.coordinates.longitude,
                                  },
                                })),
                            }}
                            callback={directionsCallback}
                          />
                        )}

                        {directionsResponse && (
                          <DirectionsRenderer
                            directions={directionsResponse}
                            options={{
                              suppressMarkers: true,
                              polylineOptions: {
                                strokeColor: "#F95C19",
                                strokeOpacity: 0.8,
                                strokeWeight: 5,
                              },
                            }}
                          />
                        )}

                        {selectedMarker && (
                          <InfoWindow
                            position={{
                              lat: selectedMarker.coordinates.latitude,
                              lng: selectedMarker.coordinates.longitude,
                            }}
                            onCloseClick={() => setSelectedMarker(null)}
                          >
                            <div>
                              <h6 style={{ margin: 0 }}>
                                HAWB: {selectedMarker.hawb}
                                <br />
                                Name: {selectedMarker.customer_name}
                                <br />
                                Address: {selectedMarker.customer_address}
                              </h6>
                            </div>
                          </InfoWindow>
                        )}

                        {startPoint && (
                          <Marker
                            position={{
                              lat: startPoint.latitude,
                              lng: startPoint.longitude,
                            }}
                            label="Start"
                          />
                        )}
                        {endPoint && (
                          <Marker
                            position={{
                              lat: endPoint.latitude,
                              lng: endPoint.longitude,
                            }}
                            label="End"
                          />
                        )}
                      </GoogleMap>
                    </LoadScript> */}
                      <LoadScript
                        googleMapsApiKey={
                          process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                        }
                      >
                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          center={
                            startPoint
                              ? {
                                  lat: startPoint.latitude,
                                  lng: startPoint.longitude,
                                }
                              : { lat: -25.2744, lng: 133.7751 }
                          }
                          zoom={6}
                        >
                          {adjustedPackageData?.map((item, index) => (
                            <Marker
                              key={item.id}
                              position={{
                                lat: item.coordinates.latitude,
                                lng: item.coordinates.longitude,
                              }}
                              label={{
                                text: `${index + 1}`,
                                color: "white",
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                              title={item.customer_address}
                              onClick={() => markerDetails(item)}
                              icon={{
                                // url: markeorange,
                                url:
                                  item.status === "Delivered"
                                    ? markegreen // Use orange for delivered
                                    : item.status === "Failed Delivery"
                                    ? markeredblack // Use red for failed
                                    : markeorange, // Use green for other statuses
                              }}
                            />
                          ))}

                          {startPoint && endPoint && (
                            <DirectionsService
                              options={{
                                origin: {
                                  lat: startPoint.latitude,
                                  lng: startPoint.longitude,
                                },
                                destination: {
                                  lat: endPoint.latitude,
                                  lng: endPoint.longitude,
                                },
                                travelMode: "DRIVING",
                                waypoints: packageData
                                  .slice(1, -1)
                                  .map((item) => ({
                                    location: {
                                      lat: item.coordinates.latitude,
                                      lng: item.coordinates.longitude,
                                    },
                                  })),
                              }}
                              callback={directionsCallback}
                            />
                          )}

                          {directionsResponse && (
                            <DirectionsRenderer
                              directions={directionsResponse}
                              options={{
                                suppressMarkers: true,
                                polylineOptions: {
                                  strokeColor: "#F95C19",
                                  strokeOpacity: 0.8,
                                  strokeWeight: 5,
                                },
                              }}
                            />
                          )}

                          {selectedMarker && (
                            <InfoWindow
                              position={{
                                lat: selectedMarker.coordinates.latitude,
                                lng: selectedMarker.coordinates.longitude,
                              }}
                              onCloseClick={() => setSelectedMarker(null)}
                            >
                              <div>
                                <h6 style={{ margin: 0 }}>
                                  <p
                                    style={{
                                      margin: "1px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong>Company Name:</strong>{" "}
                                    {selectedMarker.company_name}
                                  </p>
                                  <br />
                                  <p
                                    style={{
                                      margin: "1px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong>HAWB:</strong> {selectedMarker.hawb}
                                  </p>
                                  <br />
                                  <p
                                    style={{
                                      margin: "1px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong> Name:</strong>{" "}
                                    {selectedMarker.customer_name}
                                  </p>
                                  <br />
                                  <p
                                    style={{
                                      margin: "1px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong>Address:</strong>{" "}
                                    {selectedMarker.customer_address}
                                  </p>
                                  <br />
                                  <p
                                    style={{
                                      margin: "1px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <strong>Status:</strong>{" "}
                                    {selectedMarker.status}
                                  </p>
                                </h6>
                              </div>
                            </InfoWindow>
                          )}

                          {startPoint && (
                            <Marker
                              position={{
                                lat: startPoint.latitude,
                                lng: startPoint.longitude,
                              }}
                              label="Start"
                            />
                          )}
                          {endPoint && (
                            <Marker
                              position={{
                                lat: endPoint.latitude,
                                lng: endPoint.longitude,
                              }}
                              label="End"
                            />
                          )}
                        </GoogleMap>
                      </LoadScript>
                    </div>
                  </div>
                </Content>
              </Layout>
              {/* Right Sidebar */}
            </Layout>
          </Layout>
        </div>
      </Spin>
    </>
  );
};

// Routemap.propTypes = {
//   driverState: PropTypes.func.isRequired,
//   setDriverState: PropTypes.func.isRequired,

// };

export default Routemap;
